import { api } from "api/apiHelper";
import { Endpoints } from "api/apiConst";

export const updateCustomCardStatus = async (id: number, data: object) => {
  const endpoint = `${Endpoints.CUSTOM_CARDS_REVIEW}/${id}`;
  const response = await api.post(endpoint, data);
  return response;
};

export const getCustomCards = (params?: object) => {
  return api
    .get(Endpoints.CUSTOM_CARDS, {
      params: { ...params },
    })
    .then((response) => response.data);
};
